export const theme = {
  accent: "#4338ca",
  accentHover: "#312e81",
  accentSoftBg: "#f6f5fd",
  accentSoftBorder: "#e4e1fa",
  text: "#1b1b21",
  textMuted: "#8a8a96",
  textSecondary: "#63636f",
  border: "#e6e6ec",
  borderHover: "#b6b6c2",
  surface: "#fff",
  surfaceSubtle: "#fafafb",
  success: "#146c43",
  successBg: "#e6f4ec",
  successBar: "#1a9c5f",
  danger: "#b3312f",
  dangerText: "#a4302e",
  dangerBg: "#fdf1f0",
  dangerBadgeBg: "#f7dedc",
  neutralBar: "#c3c3cf",
  neutralBadgeBg: "#f2f2f6",
  tray: "#efeff3",
};

export const fmtRelative = (days) => {
  const a = Math.abs(days);
  if (a < 31) return `${a} ${a === 1 ? "day" : "days"}`;
  if (a < 365) return `${Math.round(a / 30)} months`;
  const y = a / 365;
  return y < 1.6 ? "1 year" : `${Math.round(y)} years`;
};
